// {
//   "storageMoveInfo":{
//       "selectCity":"",
//       "pickupAddress":"",
//       "serviceLiftAvailable":"",
//       "floorNo":"",
//       "pickupDate":"",
//   },
//   "storageInventory":"",
//   "storageProgressInfo":""
// }
export function getInitState() {
  const state = {
    selectCity: "",
    pickupAddress: "",
    serviceLiftAvailable: "No",
    floorNo: "",
    pickupDate: "",
    daysOfStorage: "",
    isMoveInfoFormSubmitting: false,
    hasError: false,
    errorMessage: "",
    hasLoadedFromSession: false,
  };
  return state;
}

export function updateMoveInfo(state, payload) {
  //   console.log("state in reducers is",state);
  const updatedState = {
    ...state,
    selectCity: payload["select_city"],
    pickupAddress: payload["pickup_address"],
    serviceLiftAvailable: payload["elevator_availability"],
    floorNo: payload["floor_no"],
    pickupDate: payload["pickup_date"],
    daysOfStorage: payload["days_of_storage"],
    isMoveInfoFormSubmitting: false,
    hasLoadedFromSession: true,
  };
  return updatedState;
}

export function updateMoveInfoFormSubmit(state, payload) {
  const updatedState = { ...state, isMoveInfoFormSubmitting: payload.status };
  return updatedState;
}

export function updateFromLocalSession(state, payload) {
  const updatedState = {
    ...state,
    selectCity: payload["select_city"],
    pickupAddress: payload["pickup_address"],
    serviceLiftAvailable: payload["elevator_availability"],
    floorNo: payload["floor_no"],
    pickupDate: new Date(payload["pickup_date"]),
    daysOfStorage: payload["days_of_storage"],
    isMoveInfoFormSubmitting: false,
    hasLoadedFromSession: true,
  };
  return updatedState;
}

export function prepareRequestData(data) {
  const formData = {
    select_city: data["select_city"],
    pickup_address: data["pickup_address"],
    pickup_date: data["pickup_date"],
    floor_no: data["floor_no"],
    // pickup_date: data["pickup_date"],
    elevator_availability: data["elevator_availability"],
    days_of_storage: data["days_of_storage"],
  };
  return formData;
}
export function loadStateFromURL(state, payload) {
  if (payload.moveType === "Within City") {
    const updatedState = {
      ...state,
      hasLoadedFromSession: true,
      moveType: payload["moveType"],
      selectCity: payload["selectCity"],
      withinCityPropertySize: payload["propertySize"],
      withinCityMovingFrom: payload["movingFrom"],
      withinCityMovingTo: payload["movingTo"],
      withinCityMovingOnDate: new Date(payload["movingOn"]),
      withinCityDistance: payload["distance"],
      withinCityDuration: payload["duration"],
      withinCityhasFlexibleDate: payload["isMoveFlexible"],

      interCityPropertySize: "1 BHK",
      interCityMovingFrom: "",
      interCityMovingTo: "",
      interCityMovingOnDate: "",
      interCityDistance: "",
      interCityhasFlexibleDate: false,
    };
    return updatedState;
  }
  if (payload.moveType === "Inter City") {
    const updatedState = {
      ...state,
      hasLoadedFromSession: true,

      moveType: payload["moveType"],
      interCityPropertySize: payload["propertySize"],
      interCityMovingFrom: payload["movingFrom"],
      interCityMovingTo: payload["movingTo"],
      interCityMovingOnDate: new Date(payload["movingOn"]),
      interCityDistance: payload["distance"],
      interCityDuration: payload["duration"],
      interCityhasFlexibleDate: payload["isMoveFlexible"],

      selectCity: "",
      withinCityPropertySize: "1 BHK",
      withinCityMovingFrom: "",
      withinCityMovingTo: "",
      withinCityMovingOnDate: "",
      withinCityDistance: "",
      withinCityhasFlexibleDate: false,
    };

    return updatedState;
  }
  return state;
}
